import $ from 'jquery';
import jQuery from 'jquery';
import 'slick-carousel';
import 'bootstrap/js/dist/tab';
import mapboxgl from 'mapbox-gl';
import { library, dom } from '@fortawesome/fontawesome-svg-core';
import {faPhone, faEnvelope, faMapPin, faCalendarMinus, faSpinner, faAngleRight} from "@fortawesome/free-solid-svg-icons";
library.add(faPhone, faEnvelope, faMapPin, faCalendarMinus, faSpinner, faAngleRight);
dom.watch();

jQuery(document).ready(function() {
    let initHome = function () {
        if ($('.block-slider').length > 0) {
            $('.block-slider').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: false,
                fade: true,
                autoplay: true,
                autoplaySpeed: 4000,
                infinite: true,
                lazyLoad: 'ondemand',
                rows: 0
            });
        }

        if ($('#activity-slick').length > 0) {
            $('#activity-slick').slick({
                slidesToShow: 5,
                slidesToScroll: 1,
                arrows: false,
                dots: false,
                fade: false,
                autoplay: false,
                autoplaySpeed: 4000,
                infinite: false,
                lazyLoad: 'ondemand',
                rows: 0,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                            centerMode: false, /* set centerMode to false to show complete slide instead of 3 */
                            dots: true,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
            $('#activity-slick').on('afterChange', function(event, slick, currentSlide) {
              $("#activity-slick [data-slick-index='"+currentSlide+"']").find('a').trigger('click');
              var target = $("#activity-slick [data-slick-index='"+currentSlide+"']").find('a').attr('data-bs-target');
              //console.log($("[data-slick-index='"+currentSlide+"']").find('a'));
              $('#pills-tabContent .tab-pane').removeClass('show');
              $('#pills-tabContent .tab-pane').removeClass('active');
              $('#pills-tabContent ' + target ).addClass('active');
              $('#pills-tabContent ' + target ).addClass('show');
            });
        }

        if ($('.content_items_slider_commitment').length > 0) {
            $('.content_items_slider_commitment').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                dots: false,
                fade: false,
                autoplay: false,
                autoplaySpeed: 4000,
                infinite: false,
                lazyLoad: 'ondemand',
                rows: 0
            });
        }

        if ($('#chiffres-slick').length > 0) {
            $('#chiffres-slick').slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                arrows: false,
                dots: false,
                fade: false,
                autoplay: false,
                infinite: false,
                lazyLoad: 'ondemand',
                rows: 0,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                            centerMode: false, /* set centerMode to false to show complete slide instead of 3 */
                            infinite: true,
                            autoplay: true,
                            autoplaySpeed: 2000,
                            dots: true,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
        }
    }

    let initChiffres = function () {
        if($('.block-chiffres').length > 0){
            let count = false;
            $(window).scroll(function () {
                if(count === false){
                    if($(window).scrollTop() >= ($('.block-chiffres').offset().top - 920)){
                        count = true;
                        $('.number_chiffres').each(function () {
                            let nb = $(this).text().replace(' ','');
                            let float = '';
                            let pref = '';
                            //console.log(nb.search(',5'));
                            if(nb.search(',5') !== -1){
                                float = ',5';
                                nb = nb.replace(',5', '');
                            }
                            if(nb.indexOf('+') >= 0){
                                pref = '+';
                                nb = nb.replace('+', '');
                            }
                            $(this).prop('Counter',($(this).text()/4)*3).animate({
                                Counter: nb
                            }, {
                                duration: 1000,
                                easing: 'swing',
                                step: function (now) {
                                    $(this).text(pref+Math.ceil(now)+float);
                                }
                            });
                        });
                    }
                }

            });
        }
    }

    let initActivityMobile = function() {
        $('#activity-slick > .slick-list > .slick-track > .nav-item > .nav-link').click(function(e) {
            e.preventDefault();
            $('#activity-slick > .slick-list > .slick-track > .nav-item > .nav-link').removeClass('active');
            $(this).addClass('active');
        })
    }

    let initReferences = function() {
        if ($('.list_references').length > 0) {
            $('.list_references').slick({
                dots: false,
                arrows: false,
                slidesToShow: 4,
                infinite: true,
                autoplay: true,
                autoplaySpeed: 0,
                speed: 5000,
                cssEase: 'linear',
                waitForAnimate: false,
                edgeFriction: false,
                pauseOnFocus: false,
                pauseOnHover: false,
                responsive: [
                    {
                        breakpoint: 769,
                        settings: {
                            dots: false,
                            slidesToShow: 4,
                            infinite: true,
                            autoplay: true,
                            autoplaySpeed: 0,
                            speed: 5000,
                            cssEase: 'linear',
                            waitForAnimate: false,
                            edgeFriction: false,
                            pauseOnFocus: false,
                            pauseOnHover: false,
                        }
                    }
                ]
            });
        }
    }

    let init_mapbox = function(){
        if( $('#plan').length > 0){
            const lngN = $('#plan').data('longitudeformarker');
            const latN = $('#plan').data('latitudeformarker');
            const markerIconURL = $('#plan').data('markericonurl');
            const descriptionForMarker = $('#plan').data('descriptionformarker');

            // initialisation de la map
            mapboxgl.accessToken = 'pk.eyJ1IjoieWFubi1ib3VldCIsImEiOiJja2g0azRlbmgwcDY1MnNsc2owbm9zOHowIn0.dNAs1QS6HrmJIZJBpXxASg';
            let map = new mapboxgl.Map({
                container: 'plan',
                style: 'mapbox://styles/mapbox/streets-v11', // stylesheet location
                center: [lngN, latN], // starting position [lng, lat]
                zoom: 16, // starting zoom
            });

            // Ajout du marqueur
            map.on('load', function () {
                map.loadImage(
                    // récupéré par champ ACF, puis passé en data
                    markerIconURL,
                    // Add an image to use as a custom marker
                    function (error, image) {
                        // S'il n'y a pas de curseur personnalisé, on charge celui par défaut
                        if (error){
                            let marker = new mapboxgl.Marker({
                                'color'  : '#48aa48',
                                'scale'  : 2
                            });

                            marker.setLngLat([lngN, latN]);
                            marker.addTo(map);
                        }
                        // On charge le curseur personnalisé
                        else{
                            map.addImage('custom-marker', image);

                            const markers = [{
                                'type': 'Feature',
                                'properties': {
                                    'description': descriptionForMarker
                                },
                                'geometry': {
                                    'type': 'Point',
                                    'coordinates': [lngN, latN]
                                }
                            }];

                            map.addSource('places', {
                                'type': 'geojson',
                                'data': {
                                    'type': 'FeatureCollection',
                                    'features': markers
                                }
                            });

                            // Add a layer showing the places.
                            map.addLayer({
                                'id': 'places',
                                'type': 'symbol',
                                'source': 'places',
                                'layout': {
                                    'icon-image': 'custom-marker',
                                    'icon-size': 0.2,
                                    'icon-anchor': 'bottom',
                                    'icon-allow-overlap': true
                                }
                            });
                        }
                    }
                );
            });

            // Create a popup, but don't add it to the map yet.
            let popup = new mapboxgl.Popup({
                closeButton: false,
                closeOnClick: false,
                anchor:'top'
            });

            map.on('mouseenter', 'places', function (e) {
                // Change the cursor style as a UI indicator.
                map.getCanvas().style.cursor = 'pointer';

                let coordinates = e.features[0].geometry.coordinates.slice();
                let description = e.features[0].properties.description;

                // Ensure that if the map is zoomed out such that multiple
                // copies of the feature are visible, the popup appears
                // over the copy being pointed to.
                while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                    coordinates[0] += (e.lngLat.lng > coordinates[0]) ? 360 : -360;
                }

                // Populate the popup and set its coordinates
                // based on the feature found.
                popup.setLngLat(coordinates).setHTML(description).addTo(map);
            });

            map.on('mouseleave', 'places', function () {
                map.getCanvas().style.cursor = '';
                popup.remove();
            });

            map.addControl(new mapboxgl.NavigationControl());
            // disable map zoom when using scroll
            map.scrollZoom.disable();
        }
    }

    let initNews = function() {
        let currentPage = $('.list-news').data('paged');
        let allPages = $('.list-news').data('allpages');
        let postPerPage = $('.list-news').data('postperpage');
        let allPosts = $('.list-news').data('foundpost');
        let category = $('.cat-list_item.active').data('slug');
        let reloadNews = function(){
            if (postPerPage < allPosts) {
                $('.more_post').css('display', 'flex');
            } else {
                $('.more_post').css('display', 'none');
            }
            $.ajax({
                type: 'POST',
                url: '/wp-admin/admin-ajax.php',
                data: {
                    action: 'app_news_more_action',
                    paged: currentPage,
                    category : category,
                    postPerPage: postPerPage,
                },
                success: function(data) {
                    if (data != '') {
                        currentPage = 1;
                        $('.list-news').html(data);
                        allPages = $('.list-news .datas').data('allpages');
                        allPosts = $('.list-news .datas').data('foundpost');
                        if (allPosts > $('.list-news .item_actu').length) {
                            $('.more_post').show();
                        } else {
                            $('.more_post').hide();
                        }
                        $('.current_posts').html($('.list-news .item_actu').length);
                        $('.nb_all_posts').html(allPosts);
                    }


                }
            });
        }
        $('.cat-list_item').click(function(e) {
            e.preventDefault();
            $('.cat-list_item').removeClass('active');
            $(this).addClass('active');
            category = $(this).data('slug');
            reloadNews();
        });
        $('.send_more').click(async function(e){
            e.preventDefault();
            $('.more_post').hide();
            $('.loading').css('display', 'flex');
            if(($('.list-news .item_actu').length  >= postPerPage) && ($('.list-news .item_actu').length < allPosts)) {
                let nextPage = currentPage + 1;
                if(nextPage <= allPages) {
                    $.ajax({
                        type: 'POST',
                        url: '/wp-admin/admin-ajax.php',
                        dataType: 'html',
                        data: {
                            action: 'load_more_posts',
                            currentPage: nextPage,
                            postPerPage: postPerPage,
                        },
                        success: function(res) {
                            currentPage++;
                            $('.list-news').append(res);
                            if ($('.list-news .item_actu').length >= allPosts) {
                                $('.more_post').hide();
                                $('.loading').css('display', 'none');
                            } else {
                                $('.more_post').show();
                                $('.loading').css('display', 'none');
                            }
                            $('.current_posts').html($('.list-news .item_actu').length);
                            $('.nb_all_posts').html(allPosts);
                        }
                    })
                }
            }
        });
    }

    let initMain = function(){
        initHome();
        initChiffres();
        initActivityMobile();
        initReferences();
        init_mapbox();
        initNews();
    }

    initMain();
});

//LAZY LOAD !!
document.addEventListener("DOMContentLoaded", function() {
    let lazyloadImages = document.querySelectorAll("img.lazy");
    let lazyloadSources = document.querySelectorAll("source.lazy");
    let lazyloadThrottleTimeout;



    function lazyload () {
        if(lazyloadThrottleTimeout) {
            clearTimeout(lazyloadThrottleTimeout);
        }

        lazyloadThrottleTimeout = setTimeout(function() {
            lazyloadImages = document.querySelectorAll("img.lazy");
            lazyloadSources = document.querySelectorAll("source.lazy");
            let scrollTop = window.pageYOffset;
            $.each(lazyloadImages, function(index, img) {
                if(img.offsetTop < (window.innerHeight + scrollTop)) {
                    img.src = img.dataset.src;
                    img.classList.remove('lazy');
                }
            });
            $.each(lazyloadSources, function(index, img) {
                if(img.offsetTop < (window.innerHeight + scrollTop)) {
                    img.srcset = img.dataset.srcset;
                    img.classList.remove('lazy');
                }
            });
            if(lazyloadSources.length == 0 && lazyloadImages.length == 0) {
                window.removeEventListener("scroll", lazyload);
                window.removeEventListener("resize", lazyload);
                window.removeEventListener("orientationChange", lazyload);
            }
        }, 20);

        let imgDefer = document.querySelectorAll('div[data-srcbg]');
        let style = "background-image: url({url})";
        for (let i = 0; i < imgDefer.length; i++) {
            imgDefer[i].setAttribute('style', style.replace("{url}", imgDefer[i].getAttribute('data-srcbg')));
        }
    }
    window.addEventListener("scroll", lazyload);
    window.addEventListener("resize", lazyload);
    window.addEventListener("orientationChange", lazyload);
// IE
    let evt = window.document.createEvent('UIEvents');
    evt.initUIEvent('resize', true, false, window, 0);
    window.dispatchEvent(evt);
});